export default __webpack_public_path__ + "static/media/likes_main.5c8f7223.png";